import { ShoppingBagIcon } from '@grupoboticario/flora-react-icons';

import { formatTotalUnitPlural } from './helpers';
import Item from './Item';
import { SUMMARY_COMPONENTS_CONST, type ItemsPointsProgramProps } from './Summary.components.d';
import { Items } from './Summary.components.styles';

const ItemsPointsProgram = ({ items = [] }: ItemsPointsProgramProps) => {
  if (!items.length) {
    return null;
  }

  const availableItemsIndex = items.findIndex((item, index) => {
    if (Object.prototype.hasOwnProperty.call(item, 'availableItems')) {
      return index - 1;
    }

    return null;
  });

  const { availableItems } = items[availableItemsIndex] || [];

  if (!availableItems.length) {
    return null;
  }

  return (
    <Items.Component data-testid={SUMMARY_COMPONENTS_CONST.POINTS_TEST_ID}>
      <Items.Title>
        <ShoppingBagIcon size={24} />
        Trocando pontos por {formatTotalUnitPlural(availableItems.length)}
      </Items.Title>

      {availableItems.map(({ image, name, productCode, quantity }) => (
        <Items.Card key={productCode} radius="rounded">
          <Item
            image={image}
            name={name}
            priceTotal="R$ 0,00"
            productCode={productCode}
            quantity={quantity}
          />
        </Items.Card>
      ))}
    </Items.Component>
  );
};

export default ItemsPointsProgram;
